import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ceres-coming-soon',
    templateUrl: './coming-soon.component.html',
    styleUrls: ['./coming-soon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ComingSoonComponent {}
